import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-loader',
  imports: [],
  templateUrl: './loader.html',
  styleUrl: './loader.css'

})
export class Loader {

}
